__turbopack_context__.v({
  "animation": "Animation-module-scss-module__7vHCpq__animation",
  "exited": "Animation-module-scss-module__7vHCpq__exited",
  "positioned": "Animation-module-scss-module__7vHCpq__positioned",
});
